import React from "react";

const CreateBulkOrderSvg = ({ stroke = "#a3a3a3", size = 21, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
  >
    <path
      d="M1.68408 12.7024L6.37502 15.4171L11.0341 12.7183"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.375 20.2303V15.4119"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.43853 11.6399C1.79571 11.9959 1.26978 12.8884 1.26978 13.6215V16.6231C1.26978 17.3562 1.79571 18.2487 2.43853 18.6046L5.2754 20.1824C5.88103 20.5171 6.87446 20.5171 7.48009 20.1824L10.317 18.6046C10.9598 18.2487 11.4857 17.3562 11.4857 16.6231V13.6215C11.4857 12.8884 10.9598 11.9959 10.317 11.6399L7.48009 10.0621C6.86915 9.72744 5.88103 9.72744 5.2754 10.0674L2.43853 11.6399Z"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.58496 4.21997L12 6.77497L16.385 4.23497"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 11.305V6.77002"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.29507 3.22014C7.69007 3.55514 7.19507 4.39514 7.19507 5.08514V7.91014C7.19507 8.60014 7.69007 9.44014 8.29507 9.77514L10.9651 11.2601C11.5351 11.5751 12.4701 11.5751 13.0401 11.2601L15.7101 9.77514C16.3151 9.44014 16.8101 8.60014 16.8101 7.91014V5.08514C16.8101 4.39514 16.3151 3.55514 15.7101 3.22014L13.0401 1.73514C12.4651 1.42014 11.5351 1.42014 10.9651 1.74014L8.29507 3.22014Z"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.4106 19.4069C22.2991 19.5981 22.1556 19.7681 21.9909 19.9062C21.6191 20.2409 21.1303 20.4375 20.5938 20.4375C19.9456 20.4375 19.3666 20.1453 18.9841 19.6885C18.9734 19.6725 18.9575 19.6619 18.9469 19.6459C18.8831 19.5716 18.8247 19.4919 18.7769 19.4069C18.5803 19.0881 18.4688 18.7109 18.4688 18.3125C18.4688 17.6431 18.7769 17.0428 19.2656 16.655C19.6322 16.3628 20.0944 16.1875 20.5938 16.1875C21.125 16.1875 21.6031 16.3787 21.975 16.7028C22.0388 16.7506 22.0972 16.8091 22.1503 16.8675C22.5009 17.25 22.7188 17.7547 22.7188 18.3125C22.7188 18.7109 22.6072 19.0881 22.4106 19.4069Z"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3854 18.3018H19.8022"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5938 17.5264V19.1148"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1841 12.7024L16.875 15.4171L21.5341 12.7183"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.875 20.2303V15.4119"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.9804 16.6285C21.9804 16.655 21.9804 16.6762 21.9751 16.7028C21.6032 16.3787 21.1251 16.1875 20.5938 16.1875C20.0945 16.1875 19.6323 16.3628 19.2657 16.655C18.777 17.0428 18.4688 17.6431 18.4688 18.3125C18.4688 18.7109 18.5804 19.0881 18.777 19.4069C18.8248 19.4919 18.8832 19.5716 18.947 19.646L17.9748 20.1825C17.3692 20.5225 16.381 20.5225 15.7754 20.1825L12.9385 18.61C12.2957 18.2541 11.7698 17.3616 11.7698 16.6285V13.6216C11.7698 12.8884 12.2957 11.9959 12.9385 11.64L15.7754 10.0675C16.381 9.7275 17.3692 9.7275 17.9748 10.0675L20.8117 11.64C21.4545 11.9959 21.9804 12.8884 21.9804 13.6216V16.6285Z"
      stroke="#AE1A1A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CreateBulkOrderSvg;
